import { render } from "./SamplingPoints.view.vue?vue&type=template&id=63dbfbeb&scoped=true&ts=true"
import script from "./SamplingPoints.view.vue?vue&type=script&lang=ts"
export * from "./SamplingPoints.view.vue?vue&type=script&lang=ts"

import "./SamplingPoints.view.vue?vue&type=style&index=0&id=63dbfbeb&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/WEAS/WEAS_CI/WEAS_FRONT/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63dbfbeb"]])

export default __exports__